import { ButtonV2 } from '@moneyforward/ap-frontend-components';
import { useTranslation } from '@/i18n';
import { FC, memo } from 'react';

export type BaseButtonGroupProps = {
  onExport?: () => void;
  onImport?: () => void;
};

/** Shared Export and Import buttons used by both ProxyOff and ProxyOn button groups. */
export const BaseButtonGroup: FC<BaseButtonGroupProps> = memo(
  ({ onExport, onImport }) => {
    const { t } = useTranslation();

    return (
      <>
        <ButtonV2 size='sm' isTertiary onClick={onExport}>
          {t('invoice_reports.button_groups.export')}
        </ButtonV2>
        <ButtonV2 size='sm' isTertiary onClick={onImport}>
          {t('invoice_reports.button_groups.import')}
        </ButtonV2>
      </>
    );
  }
);

BaseButtonGroup.displayName = 'BaseButtonGroup';
